export default Object.freeze({
  TEXT: 'text',
  NUMBER: 'number',
  DATE: 'date',
  OBJECT: 'object',
});
